import React from 'react';
import { ListGroup } from 'reactstrap';
import IndicatorListItem from './IndicatorListItem';
/**
 * Renders a list of indicators, with optional hints
 */

var IndicatorList = function IndicatorList(_ref) {
  var indicators = _ref.indicators,
      _ref$showHints = _ref.showHints,
      showHints = _ref$showHints === void 0 ? true : _ref$showHints,
      onSelect = _ref.onSelect,
      activeId = _ref.activeId;
  return /*#__PURE__*/React.createElement(ListGroup, null, indicators.map(function (indicator) {
    return /*#__PURE__*/React.createElement(IndicatorListItem, {
      key: indicator.id,
      indicator: indicator,
      showHint: showHints,
      onSelect: onSelect,
      activeId: activeId
    });
  }));
};

export default IndicatorList;